import axios from "axios";
import { API_URL, getHeaderWithAuthorization } from "./API";

// В list id приходит строкой, в detail — числом. Учитываем на фронте.
export type SchoolDoc = {
  id: string;
  name: string;
};

export type SchoolDocDetail = {
  id: number;
  name: string;
  content: string;
};

export const getSchoolDocList = async (schoolId: number | string) => {
  return axios.get<SchoolDoc[]>(`${API_URL}v2/school/doc/list/${schoolId}`, {
    headers: getHeaderWithAuthorization(),
  });
};

export const getSchoolDocDetail = async (docId: number | string) => {
  return axios.get<SchoolDocDetail>(`${API_URL}v2/school/doc/detail/${docId}`, {
    headers: getHeaderWithAuthorization(),
  });
};
